import LiveTvIcon from '@material-ui/icons/LiveTv'
import InsertPhotoOutlinedIcon from '@material-ui/icons/InsertPhotoOutlined'
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo'
import React from 'react'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
import './Sidebar.css'
import EventNoteIcon from '@material-ui/icons/EventNote'
import PolicyIcon from '@material-ui/icons/Policy'
import RedeemIcon from '@material-ui/icons/Redeem'
import InfoIcon from '@material-ui/icons/Info'
import { Link } from 'react-router-dom'

function Sidebar() {
    return (
        <div  className='sidebar'>

            <div className="sidebar__category">
                <div className="sidebar__categoryLeft">
                    <Link to='/photos'>
                 <div className="sidebar__categoryOption">
                    <InsertPhotoOutlinedIcon className='sidebar__categoryOptionIcon' />
                    <span>Photos</span>
                 </div>
                    </Link>
                    <Link to='videos'>
                 <div className="sidebar__categoryOption">
                    <OndemandVideoIcon className='sidebar__categoryOptionIcon' />
                    <span>Videos</span>
                 </div>
                 </Link>
                </div>

                <div className="sidebar__categoryRight">
                <Link to='/live'>    
                 <div className="sidebar__categoryOption">
                    <LiveTvIcon className='sidebar__categoryOptionIcon' />
                    <span>Live</span>
                 </div>
                    </Link>
                    <Link to='/community'>
                 <div className="sidebar__categoryOption">
                    <GroupAddIcon className='sidebar__categoryOptionIcon' />
                    <span>Community</span>
                 </div>
                 </Link>
                </div>

                
            </div>
            
            <div className="sidebar__bottom">
                <div className="sidebar__bottomOption">
                    <EventNoteIcon className="sidebar__bottomOptionIcon"/>
                    <span>News</span>
                </div>
                <div className="sidebar__bottomOption">
                    <RedeemIcon className="sidebar__bottomOptionIcon"/>
                    <span>Donate</span>
                </div>
                <div className="sidebar__bottomOption">
                    <PolicyIcon className="sidebar__bottomOptionIcon"/>
                    <span>Policy and Privacy</span>
                </div>
                <div className="sidebar__bottomOption">
                    <InfoIcon className="sidebar__bottomOptionIcon"/>
                    <span>About us</span>
                </div>
                
            </div>
        </div>
    )
}

export default Sidebar
